import { useDispatch } from 'react-redux';
import { addSnackbarAlerts } from 'reducers/globalSlice';
import { ErrorBoundary } from '@sentry/react';
import { useTranslation } from 'react-i18next';

const CustomErrorBoundary = ({ children, fallback }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const ErrorFallback = () => {
		if (fallback) {
			return fallback;
		} else {
			return null;
		}
	};

	const onError = error => {
		dispatch(
			addSnackbarAlerts([
				{
					type: 'error',
					message: `${t('An error occurred and has been reported to our team')}.`
				}
			])
		);
	};

	return (
		<ErrorBoundary fallback={ErrorFallback} onError={onError}>
			{children}
		</ErrorBoundary>
	);
};

export default CustomErrorBoundary;
